// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_iDo","cls2":"CiterightPreprintReport-cls2_BzX CiterightPreprintReport-cls1_iDo"};